import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';
import images from './images';

registerImages('rewards', images);

declare global {
  interface RegisteredImages {
    rewards: Record<keyof typeof images, ImageSource>;
  }
}
